import { DataTableCell as RWMC, DataTableCellProps as RWMCProps } from "@rmwc/data-table"
import { HTMLAttributes } from "react"
import omit from "lodash/omit"
import { callCSSFn, CSS, CSSFn, styled, StylePropsWithCSS } from "../../styles"
import { Align } from "../types"

export type DataTableFooterCellProps = RWMCProps &
  HTMLAttributes<HTMLTableElement> & {
    css?: CSSFn
    align?: Align
  }
const Component = (props: DataTableFooterCellProps) => <RWMC {...omit(props, `css`)} />
Component.defaultProps = {
  css: undefined,
  align: `start`,
}
export const DataTableFooterCell = styled(Component)(
  (props: StylePropsWithCSS): CSS => ({
    ...props.theme.fonts.subHeading,
    fontSize: props.theme.fontSize.body,
    ...callCSSFn(props),
  })
)
